import { render, staticRenderFns } from "./DraggableListsManageCard.vue?vue&type=template&id=d5442932&scoped=true&"
import script from "./DraggableListsManageCard.vue?vue&type=script&lang=js&"
export * from "./DraggableListsManageCard.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsManageCard.vue?vue&type=style&index=0&id=d5442932&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5442932",
  null
  
)

export default component.exports